import { useAuth } from '@/app/context';
import { UserGroup } from '@/shared/utils/get-group';
import { useEffect, useState } from 'react';

const UNDERWRITING_GROUPS = [
  UserGroup.INSURER_UNDERWRITER,
  UserGroup.INSURER_ADMINISTRATOR,
];

/**
 * Perfis que enxergam o que é da subscrição: subscritor e administrador.
 *
 * Fica entre os dois vizinhos: `useIsUnderwriterUser` esconderia o recurso do
 * administrador, e `useIsInsurerUser` abriria para todos os perfis comerciais
 * da seguradora. Mesmo par de grupos do gate de inspeção da página de Apólices
 * (`policies.inspections.read`) e do `useCanCloneGroupLifeProposal`.
 */
export function useIsUnderwriterOrAdminUser() {
  const { checkUserGroups } = useAuth();
  const [isUnderwriterOrAdminUser, setIsUnderwriterOrAdminUser] = useState<
    boolean | null
  >(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      setIsLoading(true);
      const result = await checkUserGroups(UNDERWRITING_GROUPS);
      setIsUnderwriterOrAdminUser(result);
      setIsLoading(false);
    };

    check();
  }, [checkUserGroups]);

  return { isUnderwriterOrAdminUser, isLoading };
}
